import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import getController from './Widget/controller';

const createController: CreateControllerFn = async (params) => {
  return getController(params);
};

export default createController;
